import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  FlexBox, FlexItem, Image, Link, Space
} from '@codex-brightworld/basics';

const IMAGE_SPACE = 20;

export const ProductWrapper = styled(FlexBox)`
  padding: 15px 18px 16px;
  margin: 5px 0;
  border: 1px solid ${props => props.theme.colors.neutral.grey[2]};
  border-radius: 10px;
  background-color: ${props => props.theme.colors.shades[7]};
  
  @media ${props => props.theme.breakpoints.mobile} {
    margin: 0;
  }
`;

export const Hint = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: ${props => props.theme.colors.neutral.grey[4]};
`;

const StyledLink = styled(Link)`
  font-size: 14px;
  line-height: 1.5;
  color: ${props => props.theme.colors.primary.purple};
  &:hover {
    color: ${props => props.theme.colors.primary.purple};
  }
`;

const Product = props => (
  <ProductWrapper>
    <FlexItem basis={`${props.imageWidth}px`}>
      <Space right={IMAGE_SPACE}>
        <Image
          alt={props.title}
          image={props.imageUrl}
          link={props.link}
          width={props.imageWidth}
          height={props.imageHeight}
        />
      </Space>
    </FlexItem>

    <FlexItem basis={`calc(100% - ${props.imageWidth + IMAGE_SPACE}px)`}>
      {props.hint &&
        <Hint>{props.hint}</Hint>}

      <StyledLink href={props.link}>
        {props.title}
      </StyledLink>
    </FlexItem>
  </ProductWrapper>
);

Product.propTypes = {
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  hint: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string
};

Product.defaultProps = {
  id: '',
  imageUrl: '',
  imageHeight: 70,
  imageWidth: 79,
  hint: '',
  link: '',
  title: ''
};

export default Product;
